"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetType = void 0;
var AssetType;
(function (AssetType) {
    AssetType["Asset3d"] = "asset-3d";
    AssetType["GraphicSymbol"] = "graphic-symbol";
    AssetType["Image"] = "image";
    AssetType["Publication"] = "publication";
    AssetType["StoreCommunication"] = "store-communication";
})(AssetType = exports.AssetType || (exports.AssetType = {}));
//# sourceMappingURL=asset-type.js.map